import React, { Component } from 'react';
/** Personal */
import { getDom } from '../NormalStem';

class Stem extends Component {
    render() {
        const { stem } = this.props;

        return (
            <div>
                {
                    stem.map((para, i) =>
                        <p className={para.style} key={i}>
                            {
                                para.children.map((child, index) =>
                                    child.type === 'sudoku' ?
                                        <Palace palace={child} key={index} /> :
                                        getDom(child, index)
                                )
                            }
                        </p>
                    )
                }
            </div>
        )
    }
}

class Palace extends Component {
    render() {
        const { num_list, length_w, split_w, split_h, map_image } = this.props.palace;

        // 将一维数组转为二维数组 twoDimensionArr
        const twoDimensionArr = [];
        let cacheArr = [];
        num_list.forEach((item, i) => {
            const remainder = ++i % length_w; // 余数
            cacheArr.push(item);
            if (remainder === 0) {
                twoDimensionArr.push(cacheArr);
                cacheArr = [];
            }
        });

        // 数字对应的图片
        const imgMap = {};
        map_image.forEach(item => {
            imgMap[item.num] = item.image;
        });

        return (
            <span className='palace-list'>
                {
                    twoDimensionArr.map((row, i) =>
                        <span
                            className='palace-row'
                            style={{ borderWidth: ++i % split_h === 0 ? 4 : 1 }}
                            key={i}>
                            {
                                row.map((val, index) =>
                                    <span
                                        className={`palace-item ${val ? '' : 'palace-blank'}`}
                                        style={{ borderWidth: ++index % split_w === 0 ? 4 : 1 }}
                                        key={index}>{imgMap[val] ? imgMap[val] : val}</span>
                                )
                            }
                        </span>
                    )
                }
            </span>
        )
    }
}

export default Stem;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/sudoku/Stem.js